import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import { Button, ReduxControls } from 'rhombus-react';
import { reduxForm, reset, isValid, initialize, Field, getFormValues } from "redux-form";

import { CREATE_IMPOSIUM_PROJECT_WITH_CREATIVES_FORM, ADD_CREATIVES_TO_IMPOSIUM_PROJECT_FORM, IMPOSIUM_MULTI_CREATIVE_FORM } from "widgets/forms/list";
import BasicModal from "widgets/modals/BasicModal";

import NewImposiumWithCreativesForm from "widgets/modals/imposium/NewImposiumWithCreativesForm";
import AddCreativesToImposiumProjectModal from "widgets/modals/imposium/AddCreativesToImposiumProjectModal";

import ImposiumProjectsTable from "widgets/modals/imposium/ImposiumProjectsTable";


import "./CreateImposiumProjectModal.css";


export function ImposiumMultiCreativeModal(props){
	const { navigationActions, onClose, initialized } = props;
	const dispatch = useDispatch();
	const {
		libraryId,
		isSaving,
		selectedProject,
	} = useSelector((state) => {
		return {
			libraryId: state.libraryProperties.id,
			isSaving: state.imposiumProjects.isSaving,
			selectedProject: state.imposiumProjects.selectedProject,
		};
	});
	const values = useSelector(getFormValues(IMPOSIUM_MULTI_CREATIVE_FORM)) || {};
	const useExistingProject = values?.newOrExistingProject === 'existingProject';

	useEffect(() => {
		if (!initialized) {
			dispatch(initialize(IMPOSIUM_MULTI_CREATIVE_FORM, { newOrExistingProject: 'newProject' }));
		}
	}, [initialized]);

	const isNewProjectValid = useSelector(isValid(CREATE_IMPOSIUM_PROJECT_WITH_CREATIVES_FORM));
	const valid = useExistingProject ? !!selectedProject : isNewProjectValid;

	function onBack() {
		dispatch(reset(CREATE_IMPOSIUM_PROJECT_WITH_CREATIVES_FORM));
		dispatch(reset(ADD_CREATIVES_TO_IMPOSIUM_PROJECT_FORM));
		dispatch(reset(IMPOSIUM_MULTI_CREATIVE_FORM));
		navigationActions?.popModal();
	}

	function onExit(){
		dispatch(reset(CREATE_IMPOSIUM_PROJECT_WITH_CREATIVES_FORM));
		dispatch(reset(ADD_CREATIVES_TO_IMPOSIUM_PROJECT_FORM));
		dispatch(reset(IMPOSIUM_MULTI_CREATIVE_FORM));
		onClose();
	}

	function renderContent(){
		const headerContent = () => {
			return (
				<header className="header-imposium">

					<Field
						name={`newOrExistingProject`}
						component={ReduxControls.Checkbox}
						placeholder="Creative name"
						label={"New Imposium Project"}
						value="newProject"
						type="radio"
					/>

					<Field
						name={`newOrExistingProject`}
						component={ReduxControls.Checkbox}
						placeholder="Creative name"
						label={"Select Existing Imposium Project"}
						value="existingProject"
						type="radio"
					/>
				</header>
			);
		};

		return (
			<div>
				{headerContent()}
				<div className="imposium-modal-main-content">
					{useExistingProject ? <ImposiumProjectsTable libraryId={libraryId} /> : <NewImposiumWithCreativesForm onClose={onExit} libraryId={libraryId} />}
				</div>
			</div>
		);
	}

	const openAddCreativesModal = () => {
		function addCreativesModal(props) {
			const modalProps = {
				...props,
				navigationActions,
				libraryId,
				selectedProject,
				onClose: onExit,
			};

			return <AddCreativesToImposiumProjectModal {...modalProps} />;
		}
		navigationActions.pushModal(addCreativesModal);
	};

	function renderFooter(){
		let createButton = (
			<Button
				key="create"
				disabled={isSaving || !valid}
				type="submit"
				theme="green"
				form={CREATE_IMPOSIUM_PROJECT_WITH_CREATIVES_FORM}
			>
				Create
			</Button>
		);

		let selectButton = (
			<Button
				key="selectProject"
				disabled={!selectedProject}
				theme="blue"
				onClick={openAddCreativesModal}
			>
				Select Imposium Project
			</Button>
		);

		return ([
			<Button key="back" theme="default" onClick={onBack}>Back</Button>,
			(useExistingProject ? selectButton : createButton),
		]);
	}

	const modalProps = {
		title: `Create VAST - Dynamic - Imposium (Advanced Video)`,
		onClose: onExit,
		className: "create-imposium-project-modal create-imposium-project-multi-creative",
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

ImposiumMultiCreativeModal.displayName = "ImposiumMultiCreativeModal";


export default reduxForm({
	form: IMPOSIUM_MULTI_CREATIVE_FORM,
	destroyOnUnmount: false,
})(ImposiumMultiCreativeModal);
